import React from 'react'
import { Panel } from '../common/Panel'
import moment from 'moment'
import vis from 'vis'
import '../../../node_modules/vis/dist/vis.css'

class EvenimentsPanelTimeline extends React.Component {
    constructor(props) {
        super(props)

        this.loaded = false
        this.options = {
            groupOrder: 'content',
            // zoomKey: 'ctrlKey',
            maxHeight: 600,
            start: moment().startOf('month').format(),
            end: moment().endOf('month').format(),
            tooltip: {
                followMouse: true,
                overflowMethod: 'cap'
            }
        }
    }

    componentDidMount() {
        this.renderTimeline()
    }

    componentDidUpdate() {
        if(!this.loaded) {
            this.renderTimeline()
        }
    }

    renderTimeline() {
        if(this.props.artists.length > 0) {
            this.loaded = true
            
            this.groups = new vis.DataSet()
            this.props.artists.map(artist => this.groups.add({
                id: artist.id,
                content: artist.name
            }))

            this.items = new vis.DataSet()
            this.props.eveniments.map(eveniment => {
                let place = this.props.places.find(placeI => placeI.id === eveniment.placeId)

                return this.items.add({
                    id: eveniment.id,
                    group: eveniment.artistId,
                    content: '',
                    title: place ? place.name : 'Ocupat',
                    start: eveniment.startdate
                })
            })
            
            this.timeline = new vis.Timeline(document.querySelector('#vis'))
            this.timeline.setOptions(this.options)
            this.timeline.setGroups(this.groups)
            this.timeline.setItems(this.items)
        }
    }

    render() {
        return (
            <Panel>
                <div id="vis"></div>
            </Panel>
        )
    }
}

export default EvenimentsPanelTimeline


// WEBPACK FOOTER //
// ./src/components/eveniments/EvenimentsPanelTimeline.js